import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import InputEmail from "./InputEmail"
import Field from "../Field"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"

export const defaultEmailSchema = {
  required: true,
  disabled: false,
  maxLength: 254
}

export function EmailField(props) {
  const {
    className,
    error,
    id,
    label,
    labelId,
    name,
    schema,
    onChange,
    isClearable = true,
    touched = false,
    onBlur = _.noop,
    ...rest
  } = props

  const handleChange = e => onChange(name, e.target.value)
  const handleClear = () => onChange(name, "")
  const handleBlur = e => onBlur(name, e.target.value)

  const emailSchema = _.merge(defaultEmailSchema, schema)

  return (
    <Field className={classNames("oj-email-field", className)} touched={touched} error={error}>
      <Field.Label id={labelId} inputId={id} label={label} required={emailSchema.required}>
        <Field.Input
          {...emailSchema}
          {...rest}
          id={id}
          error={error}
          name={name}
          onBlur={handleBlur}
          onClear={handleClear}
          isClearable={isClearable}
        >
          {innerProps => <InputEmail {...innerProps} onChange={handleChange} />}
        </Field.Input>
      </Field.Label>
    </Field>
  )
}

EmailField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  isClearable: PropTypes.bool,
  name: PropTypes.string.isRequired,
  labelId: PropTypes.string,
  label: PropTypes.node,
  schema: PropTypes.shape(fieldSchemaPropTypes),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  touched: PropTypes.bool
}

export default EmailField
